import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import type { PartyIdentificationImageDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { PDFDetail } from "Components/Shared/PartyIdentificationImages/PDFDetail";
import { ImageDetail } from "Components/Shared/PartyIdentificationImages/ImageDetail.";

type Props = {
  image: PartyIdentificationImageDto;
  defaultExpanded?: boolean;
};

export const ImageCard = ({
  defaultExpanded = false,
  image: { mimeType, base64Data, imageType },
}: Props) => {
  const { t } = useResource();

  const dataSrc = `data:${mimeType};base64,${base64Data}`;
  const label = t(Resources.AML.IdentificationImageType[imageType]);
  const isPdf = mimeType === "application/pdf";

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{
        borderRadius: 1,
        borderBottom: 0,
        backgroundColor: "background.paper",
        "&::before": { display: "none" },
        "&:last-child": {
          borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {isPdf ? (
          <PDFDetail base64Data={base64Data} />
        ) : (
          <ImageDetail dataSrc={dataSrc} label={label} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};
